import { render, staticRenderFns } from "./ProposalStakeholders.vue?vue&type=template&id=39737eca"
import script from "./ProposalStakeholders.vue?vue&type=script&lang=js"
export * from "./ProposalStakeholders.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports